import Api from "~/service/Api";

class CreditAccountRepository {
  fetch(query = {}) {
    return Api.get("/credit/accounts", query);
  }
}

export default CreditAccountRepository;
